import React, { useState, useEffect, useRef } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import classNames from 'classnames/bind';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import HeaderImg from '../../assets/img/home/header.png';
import FilterImg from '../../assets/img/home/filter.png';
import RandomImg from '../../assets/img/home/random.png';
import SortImg from '../../assets/img/home/sort.png';
import SearchImg from '../../assets/img/home/search.png';
import AddNewImg from '../../assets/img/home/new.png';

import { NotificationManager } from 'react-notifications';
import useFirestore from '../../hooks/useFirestore';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './styles';

const filterItems = [
  {
    category_id: 1,
    description: `Terms <br/> to <br/> KNOW`,
    selected: true,
  },
  {
    category_id: 2,
    description: `Terms with <br/> MULTIPLE <br/> MEANINGS`,
    selected: true,
  },
  {
    category_id: 3,
    description: `Terms <br/> to <br/> AVOID`,
    selected: true,
  },
];

const sortItems = [
  {
    id: 1,
    label: 'Title A-Z',
    value: 'title',
  },
  {
    id: 2,
    label: 'Title Z-A',
    value: 'title_desc',
  },
  {
    id: 3,
    label: 'Submitted By',
    value: 'submitted_by',
  },
  {
    id: 4,
    label: 'Category',
    value: 'category_id',
  },
  {
    id: 5,
    label: 'Date Added',
    value: 'created_at',
  },
];

const useOnClickOutside = (ref, handler, exceptional) => {
  useEffect(() => {
    const listener = (event) => {
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        exceptional.current.contains(event.target)
      ) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, exceptional]);
};

export default function Home() {
  const classes = useStyles();
  const firestore = useFirestore();

  const [showDropDown, setShowDropDown] = useState(false);
  //const [isLoading, setLoading] = useState(false);
  const [filterOptions, setFilterOpitons] = useState(filterItems);
  const [terms, setTerms] = useState([]);
  const [filteredTerms, setFilteredTerms] = useState([]);
  const [searchStr, setSearchStr] = useState('');
  const [newTerm, setNewTerm] = useState({
    title: '',
    category_id: '',
    submitted_by: '',
    aka: '',
    suggested_use: '',
    description: '',
  });
  const [selectedSortOption, setSelectedSortOption] = useState(sortItems[0]);
  const ref = useRef();
  const exceptional = useRef();

  useOnClickOutside(ref, () => setShowDropDown(false), exceptional);

  const toggleDropDown = () => {
    setShowDropDown(!showDropDown);
  };

  const [isShowModal, setIsShowModal] = useState(false);

  const handleClose = () => {
    setIsShowModal(false);
  };

  const handleChange = (event) => {
    setNewTerm({ ...newTerm, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    const fn = async () => {
      //setLoading(true);
      const result = await firestore.collection('terms').where('status', '==', 'Published').get();

      if (!result.empty) {
        const data = await result.docs.map((doc) => ({ ...doc.data() }));
        setTerms(data);
        setFilteredTerms(data);
      } else {
        setTerms([]);
        setFilteredTerms([]);
      }
      //setLoading(false);
    };

    fn();
  }, [firestore]);

  const filterTerms = async (filter) => {
    setFilterOpitons(
      filterOptions.map((option) => {
        if (option.category_id === filter.category_id) {
          return { ...option, selected: !option.selected };
        }
        return option;
      }),
    );
  };

  useEffect(() => {
    const selected_categories = filterOptions
      .filter((op) => op.selected === true)
      .map((op) => op.category_id);
    setFilteredTerms(
      terms.filter((t) => {
        return selected_categories.length === 0 || selected_categories.includes(t.category_id);
      }),
    );
  }, [filterOptions, terms]);

  useEffect(() => {
    setFilteredTerms(
      terms.filter((t) => {
        return t['title'].includes(searchStr) || t['description'].includes(searchStr);
      }),
    );
  }, [searchStr, terms]);

  const sortTerms = async (option) => {
    console.log(option);

    setSelectedSortOption(option);
    setShowDropDown(false);

    if (option.value === 'title_desc') {
      filteredTerms.sort((a, b) => {
        console.log(a['title'], b['title'], a['title'] < b['title']);
        if (a['title'] < b['title']) return 1;
        else if (a['title'] > b['title']) return -1;
        return 0;
      });
      setFilteredTerms(filteredTerms);
    } else {
      filteredTerms.sort((a, b) => {
        if (a[option.value] > b[option.value]) return 1;
        else if (a[option.value] < b[option.value]) return -1;
        return 0;
      });
      setFilteredTerms(filteredTerms);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newTerm.title !== '' && newTerm.submitted_by !== '') {
      await firestore
        .collection('terms')
        .add({ ...newTerm, created_at: new Date(), status: 'Draft' });
      NotificationManager.success('Term Create Success');
    }
  };

  const getRandom = () => {
    const randonTerm = terms[Math.floor(Math.random() * terms.length)];
    setFilteredTerms([randonTerm]);
  };

  return (
    <div className={classes.home}>
      <div className="container">
        <div className="header">
          <LazyLoadImage alt="headerImage" src={HeaderImg} width={900} height={500} />
        </div>
        <div className="filter card flex-item">
          <img src={FilterImg} alt="filterImage" />
          <p>Filter By Category</p>
          {filterOptions.map((filter, index) => (
            <div
              className={classNames('card', {
                'term-know': filter.category_id === 1,
                'term-multiple': filter.category_id === 2,
                'term-avoid': filter.category_id === 3,
                active: filter.selected,
              })}
              key={index}
              dangerouslySetInnerHTML={{ __html: filter.description }}
              onClick={() => filterTerms(filter)}
            ></div>
          ))}
        </div>
        <div className="other-actions">
          <button className="random-btn card" onClick={getRandom}>
            <img src={RandomImg} alt="Random" />
            <span>RANDOM</span>
          </button>
          <div className="sort-field">
            <div className="sort-header card" onClick={() => toggleDropDown()} ref={exceptional}>
              <img src={SortImg} alt="Sort" />
              <span>SORT</span>
            </div>
            {showDropDown && (
              <div className="sort-list" ref={ref}>
                <ul>
                  {sortItems.map((item) => (
                    <li
                      onClick={() => sortTerms(item)}
                      key={item.id}
                      className={item.id === selectedSortOption.id ? 'active' : ''}
                    >
                      {item.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="search-field card">
            <img src={SearchImg} alt="searchImage" />
            <span>SEARCH:</span>
            <input
              type="text"
              value={searchStr}
              name="searchStr"
              onChange={(e) => {
                setSearchStr(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="card add-new-field" onClick={() => setIsShowModal(true)}>
          <img src={AddNewImg} alt="" />
          <span>ADD NEW (SUGGEST A TERM THAT NEEDS DEFINING!)</span>
        </div>
        <div className="word-list">
          {filteredTerms.map((term, index) => (
            <div
              className={classNames('word-item ', {
                know: term.category_id === 1,
                multiple: term.category_id === 2,
                avoid: term.category_id === 3,
              })}
              key={index}
            >
              <div className="left-side">
                <h3>{term.title}</h3>
                <p className="title">Submitted by: </p>
                <div>
                  <p>{term.submitted_by}</p>
                </div>
                <p className="title">Also Known As:</p>
                <div>
                  <p>{term.aka}</p>
                </div>
                {/* <p className="title">Suggested Use:</p>
                <div>{term.suggested_use}</div> */}
              </div>
              <div
                className="right-side"
                dangerouslySetInnerHTML={{ __html: term.description }}
              ></div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        open={isShowModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paper}>
          <h2>Suggest a new term for us to define!</h2>
          <form action="#" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  required
                  id="title"
                  label="Title"
                  variant="outlined"
                  name="title"
                  value={newTerm.title}
                  onChange={handleChange}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="submitted_by"
                  label="Submitted By"
                  variant="outlined"
                  name="submitted_by"
                  value={newTerm.submitted_by}
                  onChange={handleChange}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
            </Grid>
            <div className="actions">
              <Button variant="contained" color="primary" type="submit">
                Create
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClose}
                className={classes.button}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}
